export const SCHEDULE = "SCHEDULE";
export const SCHEDULE_LOADING = "SCHEDULE_LOADING";
export const SCHEDULE_IS_ARCHIVE = "SCHEDULE_IS_ARCHIVE";
